export default "__VITE_ASSET__5dd4cb2a__"